
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function GlobalApiMessages() {
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const forbiddenHandler = (event) => {
      setMessage({
        type: "forbidden",
        title: "Permission denied",
        text:
          event.detail?.message ||
          "You do not have permission to perform this action.",
      });
    };

    const unauthenticatedHandler = (event) => {
      setMessage({
        type: "unauthenticated",
        title: "Session expired",
        text:
          event.detail?.message ||
          "Please sign in again.",
      });
    };

    window.addEventListener(
      "spend2connect:forbidden",
      forbiddenHandler,
    );

    window.addEventListener(
      "spend2connect:unauthenticated",
      unauthenticatedHandler,
    );

    return () => {
      window.removeEventListener(
        "spend2connect:forbidden",
        forbiddenHandler,
      );

      window.removeEventListener(
        "spend2connect:unauthenticated",
        unauthenticatedHandler,
      );
    };
  }, []);

  const close = () => {
    const current = message;
    setMessage(null);

    if (
      current?.type ===
      "unauthenticated"
    ) {
      navigate("/login", {
        replace: true,
      });
    }
  };

  return (
    <Dialog
      open={Boolean(message)}
      onClose={close}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "0.84rem",
          fontWeight: 850,
        }}
      >
        {message?.title}
      </DialogTitle>

      <DialogContent dividers>
        <Typography
          sx={{
            fontSize: "0.72rem",
            lineHeight: 1.6,
          }}
        >
          {message?.text}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          onClick={close}
          sx={{
            borderRadius: 0,
            fontSize: "0.7rem",
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
